import { component } from 'picoapp';

export default component((node) => {
  const video = node.querySelector('video');
  const fallback = node.querySelector('picture, img');

  const play = async () => {
    try {
      await video.play();

      video.hidden = false;
      fallback?.setAttribute('hidden', true);
    } catch {
      video.hidden = true;

      fallback?.setAttribute('hidden', true);
      fallback.addEventListener('click', play);
    }
  };

  const pause = () => {
    video.pause();
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        play();
      } else {
        pause();
      }
    });
  });

  observer.observe(video);
});
